/**
 * Custom Photo Customizer (in-house, not the Zakeke app) — Expert Canvas
 * Canvas Art (4-step wizard) + Crystal Print (3-step wizard)
 * Step 3/4: local photo upload → live SVG preview inside crystal/canvas shape
 */
(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════════
     CRYSTAL SHAPE DEFINITIONS  (SVG paths + viewBox)
  ═══════════════════════════════════════════════════════════════ */
  var CRYSTAL = {
    heart: {
      vb: '0 0 280 260',
      clip: 'M140 250 C40 180 6 130 6 82 C6 36 42 6 84 6 C110 6 132 20 140 44 C148 20 170 6 196 6 C238 6 274 36 274 82 C274 130 240 180 140 250Z',
      hl:   'M78 28 C90 18 112 14 130 20'
    },
    cube: {
      vb: '0 0 280 310',
      clip:      'M140 18 L268 88 L268 222 L140 292 L12 222 L12 88Z',
      topFace:   'M140 18 L268 88 L140 158 L12 88Z',
      rightFace: 'M140 158 L268 88 L268 222 L140 292Z',
      inner:     'M140 18 L140 158 M12 88 L140 158 L268 88',
      hl:        'M56 60 C76 50 108 44 130 48'
    },
    rectangle: {
      vb: '0 0 220 290',
      clip: 'M16 12 H204 V278 H16Z',
      hl:   'M28 24 C50 20 80 18 100 22'
    },
    oval: {
      vb: '0 0 260 290',
      clip: 'M130 8 C196 8 252 66 252 145 C252 224 196 282 130 282 C64 282 8 224 8 145 C8 66 64 8 130 8Z',
      hl:   'M54 42 C70 28 96 22 120 26'
    },
    star: {
      vb: '0 0 280 270',
      clip: 'M140 5 L172 91 L264 95 L192 152 L216 240 L140 190 L64 240 L88 152 L16 95 L108 91Z',
      hl:   'M105 42 C116 32 132 26 148 30'
    },
    diamond: {
      vb:     '0 0 240 300',
      clip:   'M120 8 L232 122 L120 292 L8 122Z',
      facet:  'M8 122 L232 122',
      hl:     'M58 58 C74 44 100 36 120 40'
    },
    'glass-frame': {
      vb:        '0 0 280 260',
      clip:      'M20 20 H260 V240 H20Z',
      outerFrame: 'M6 6 H274 V254 H6Z',
      frameEdges: 'M6 6 L20 20 M274 6 L260 20 M6 254 L20 240 M274 254 L260 240',
      hl:        'M28 28 C56 20 100 16 140 20'
    },
    iceberg: {
      vb:    '0 0 240 320',
      clip:  'M120 8 L210 60 L228 140 L200 220 L160 290 L120 312 L80 290 L40 220 L12 140 L30 60Z',
      facet: 'M120 8 L120 312 M30 60 L228 60 M12 140 L228 140 M40 220 L200 220',
      hl:    'M60 38 C80 24 106 18 128 22'
    },
    notch: {
      vb:    '0 0 280 220',
      clip:  'M30 8 H250 L272 30 V190 L250 212 H30 L8 190 V30Z',
      facet: 'M8 30 L30 8 M272 30 L250 8 M8 190 L30 212 M272 190 L250 212',
      hl:    'M36 20 C70 14 120 12 160 16'
    }
  };

  /* ═══════════════════════════════════════════════════════════════
     CANVAS SIZE DATA   keyed [orientation][panelCount]
  ═══════════════════════════════════════════════════════════════ */
  var CANVAS_SIZES = {
    horizontal: {
      1: [
        { dim: '10″ \xd7 8″',   note: 'Small wall display',  pop: false, price: 29  },
        { dim: '16″ \xd7 12″',  note: 'Standard wall art',   pop: false, price: 49  },
        { dim: '20″ \xd7 16″',  note: 'Feature piece',       pop: true,  price: 69  },
        { dim: '24″ \xd7 18″',  note: 'Large print',         pop: false, price: 89  },
        { dim: '30″ \xd7 20″',  note: 'Statement print',     pop: false, price: 119 },
        { dim: '40″ \xd7 30″',  note: 'Gallery wall hero',   pop: false, price: 159 }
      ],
      2: [
        { dim: '16″ \xd7 8″',   note: 'Compact diptych',  pop: false, price: 79  },
        { dim: '24″ \xd7 12″',  note: 'Standard diptych', pop: false, price: 109 },
        { dim: '32″ \xd7 16″',  note: 'Feature diptych',  pop: true,  price: 149 },
        { dim: '48″ \xd7 20″',  note: 'Grand diptych',    pop: false, price: 199 }
      ],
      3: [
        { dim: '24″ \xd7 8″',   note: 'Compact triptych',  pop: false, price: 99  },
        { dim: '36″ \xd7 12″',  note: 'Standard triptych', pop: false, price: 139 },
        { dim: '48″ \xd7 16″',  note: 'Feature triptych',  pop: true,  price: 189 },
        { dim: '60″ \xd7 20″',  note: 'Grand triptych',    pop: false, price: 249 }
      ],
      4: [
        { dim: '32″ \xd7 8″',   note: 'Compact quad',  pop: false, price: 139 },
        { dim: '48″ \xd7 12″',  note: 'Standard quad', pop: true,  price: 189 },
        { dim: '60″ \xd7 16″',  note: 'Feature quad',  pop: false, price: 249 }
      ],
      5: [
        { dim: '40″ \xd7 8″',   note: 'Compact 5-panel',  pop: false, price: 169 },
        { dim: '60″ \xd7 12″',  note: 'Standard 5-panel', pop: true,  price: 229 }
      ]
    },
    square: {
      1: [
        { dim: '8″ \xd7 8″',    note: 'Mini square',   pop: false, price: 29  },
        { dim: '12″ \xd7 12″',  note: 'Small square',  pop: false, price: 45  },
        { dim: '16″ \xd7 16″',  note: 'Medium square', pop: true,  price: 65  },
        { dim: '20″ \xd7 20″',  note: 'Large square',  pop: false, price: 89  },
        { dim: '24″ \xd7 24″',  note: 'XL square',     pop: false, price: 119 }
      ],
      2: [
        { dim: '16″ \xd7 8″',   note: 'Mini diptych',     pop: false, price: 79  },
        { dim: '24″ \xd7 12″',  note: 'Standard diptych', pop: true,  price: 109 },
        { dim: '32″ \xd7 16″',  note: 'Large diptych',    pop: false, price: 149 }
      ],
      3: [
        { dim: '24″ \xd7 8″',   note: 'Compact triptych',  pop: false, price: 99  },
        { dim: '36″ \xd7 12″',  note: 'Standard triptych', pop: true,  price: 139 },
        { dim: '48″ \xd7 16″',  note: 'Large triptych',    pop: false, price: 189 }
      ],
      4: [
        { dim: '32″ \xd7 8″',   note: 'Compact quad',  pop: false, price: 139 },
        { dim: '48″ \xd7 12″',  note: 'Standard quad', pop: true,  price: 189 }
      ],
      5: [
        { dim: '40″ \xd7 8″',   note: 'Compact 5-panel', pop: true, price: 169 }
      ]
    },
    vertical: {
      1: [
        { dim: '8″ \xd7 10″',   note: 'Portrait mini',     pop: false, price: 29  },
        { dim: '12″ \xd7 16″',  note: 'Portrait small',    pop: false, price: 49  },
        { dim: '16″ \xd7 20″',  note: 'Portrait standard', pop: true,  price: 69  },
        { dim: '18″ \xd7 24″',  note: 'Portrait large',    pop: false, price: 89  },
        { dim: '20″ \xd7 30″',  note: 'Feature portrait',  pop: false, price: 119 },
        { dim: '24″ \xd7 36″',  note: 'Statement portrait',pop: false, price: 159 }
      ],
      2: [
        { dim: '8″ \xd7 16″',   note: 'Compact stack', pop: false, price: 79  },
        { dim: '12″ \xd7 24″',  note: 'Standard stack',pop: true,  price: 109 },
        { dim: '16″ \xd7 32″',  note: 'Tall stack',    pop: false, price: 149 }
      ],
      3: [
        { dim: '8″ \xd7 24″',   note: 'Compact column', pop: false, price: 99  },
        { dim: '12″ \xd7 36″',  note: 'Standard column',pop: true,  price: 139 },
        { dim: '16″ \xd7 48″',  note: 'Tall column',    pop: false, price: 189 }
      ],
      4: [
        { dim: '8″ \xd7 32″',   note: 'Compact',  pop: false, price: 139 },
        { dim: '12″ \xd7 48″',  note: 'Standard', pop: true,  price: 189 }
      ],
      5: [
        { dim: '8″ \xd7 40″',   note: 'Compact',  pop: false, price: 169 },
        { dim: '12″ \xd7 60″',  note: 'Standard', pop: true,  price: 229 }
      ]
    }
  };

  var CRYSTAL_PRICES = { small: 39, medium: 59, large: 89, xlarge: 119 };

  var LAYOUT_LABELS = { 1: 'Single', 2: 'Diptych', 3: 'Triptych', 4: 'Quad', 5: '5-Panel' };

  /* ═══════════════════════════════════════════════════════════════
     WIZARD STATE
  ═══════════════════════════════════════════════════════════════ */
  var canvasState = { step: 1, style: null, orientation: 'horizontal', layout: 1, size: null };
  var crystalState = { step: 1, shape: null, size: null, effect: '3d', _lastDataUrl: null, _panX: 0, _panY: 0, _scale: 1 };

  /* ═══════════════════════════════════════════════════════════════
     MODAL OPEN / CLOSE
  ═══════════════════════════════════════════════════════════════ */
  var _savedScrollY = 0;

  function openModal(id) {
    var ov = document.getElementById(id);
    if (!ov) return;
    _savedScrollY = window.scrollY || window.pageYOffset;
    ov.removeAttribute('hidden');
    ov.offsetHeight; // force reflow
    ov.classList.add('is-open');
    document.body.classList.add('zkk-modal-open');
    var first = ov.querySelector('button,[href],input,select,[tabindex]:not([tabindex="-1"])');
    if (first) first.focus();
    if (id === 'zkk-canvas-modal')  resetCanvas();
    if (id === 'zkk-crystal-modal') resetCrystal();
  }

  function closeModal(ov) {
    if (!ov) return;
    ov.classList.remove('is-open');
    document.body.classList.remove('zkk-modal-open');
    window.scrollTo(0, _savedScrollY);
    var opener = ov._opener;
    setTimeout(function () { ov.setAttribute('hidden', ''); }, 320);
    if (opener) { opener.focus(); ov._opener = null; }
    if (ov.id === 'zkk-canvas-modal') resetUploadUI('canvas');
    if (ov.id === 'zkk-crystal-modal') resetUploadUI('crystal');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.zkk-overlay.is-open');
    if (open) closeModal(open);
  });

  document.addEventListener('click', function (e) {
    var ov = e.target.closest('.zkk-overlay');
    if (ov && e.target === ov) closeModal(ov);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.zkk-modal__close');
    if (btn) closeModal(btn.closest('.zkk-overlay'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zkk-open]');
    if (!btn) return;
    e.preventDefault();
    var type = btn.getAttribute('data-zkk-open');
    var id = type === 'crystal' ? 'zkk-crystal-modal' : 'zkk-canvas-modal';
    var m = document.getElementById(id);
    if (m) m._opener = btn;
    openModal(id);
  });

  /* ═══════════════════════════════════════════════════════════════
     STEP HELPERS
  ═══════════════════════════════════════════════════════════════ */
  function goToPanel(modal, step) {
    modal.querySelectorAll('.zkk-panel').forEach(function (p) {
      var n = parseInt(p.getAttribute('data-panel'), 10);
      n === step ? p.removeAttribute('hidden') : p.setAttribute('hidden', '');
    });
    modal.querySelectorAll('.zkk-step').forEach(function (s) {
      var n = parseInt(s.getAttribute('data-step'), 10);
      s.classList.toggle('is-active', n === step);
      s.classList.toggle('is-done',   n < step);
    });
    modal.scrollTop = 0;
  }

  function enableNext(panel, on) {
    var btn = panel && panel.querySelector('.zkk-btn--next');
    if (btn) btn.disabled = !on;
  }

  /* ═══════════════════════════════════════════════════════════════
     GRAYSCALE CONVERSION  (canvas pixel manipulation)
     Returns a grayscale data-URL with brightness/contrast boost
     to mimic real 3D laser-engraving look.
  ═══════════════════════════════════════════════════════════════ */
  function toGrayscaleDataUrl(img, targetW, targetH) {
    var canvas = document.createElement('canvas');
    canvas.width  = targetW;
    canvas.height = targetH;
    var ctx = canvas.getContext('2d');

    /* draw source image scaled to fill */
    var srcRatio = img.naturalWidth / img.naturalHeight;
    var dstRatio = targetW / targetH;
    var sx, sy, sw, sh;
    if (srcRatio > dstRatio) {
      sh = img.naturalHeight; sw = sh * dstRatio;
      sx = (img.naturalWidth - sw) / 2; sy = 0;
    } else {
      sw = img.naturalWidth; sh = sw / dstRatio;
      sx = 0; sy = (img.naturalHeight - sh) / 2;
    }
    ctx.drawImage(img, sx, sy, sw, sh, 0, 0, targetW, targetH);

    /* Laser-engraving simulation:
       Real 3D crystal = dark/navy interior, subjects glow bright white.
       We: high-contrast grayscale → darken shadows heavily → lift highlights */
    var imageData = ctx.getImageData(0, 0, targetW, targetH);
    var d = imageData.data;
    for (var i = 0; i < d.length; i += 4) {
      /* luminance-weighted grayscale */
      var gray = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
      /* strong S-curve: crush shadows, lift highlights — real engraving look */
      var t = gray / 255;
      t = t < 0.5
        ? 2 * t * t                          /* darken shadows */
        : 1 - Math.pow(-2 * t + 2, 2) / 2;  /* lift highlights */
      /* extra contrast punch */
      t = (t - 0.5) * 1.5 + 0.5;
      gray = Math.max(0, Math.min(255, t * 255));
      d[i] = d[i + 1] = d[i + 2] = gray;
    }
    ctx.putImageData(imageData, 0, 0);
    return canvas.toDataURL('image/jpeg', 0.92);
  }

  /* ═══════════════════════════════════════════════════════════════
     SVG PREVIEW — CRYSTAL
     Renders a realistic 3D crystal with grayscale engraved photo,
     thick glass edges, glowing border, sparkles, and dark base.
  ═══════════════════════════════════════════════════════════════ */
  function buildCrystalSVG(dataUrl, shape, effect, grayDataUrl) {
    var def = CRYSTAL[shape];
    if (!def) return '';

    /* use grayscale version if available, else fall back (shows colour) */
    var photoSrc = grayDataUrl || dataUrl;

    var vbParts = def.vb.split(' ');
    var W = parseInt(vbParts[2], 10);
    var H = parseInt(vbParts[3], 10);
    var uid = 'zk' + Math.random().toString(36).slice(2, 7);
    var cid = uid + 'c';   /* clip path */
    var gid = uid + 'g';   /* glass overlay gradient */
    var rid = uid + 'r';   /* radial glow */
    var bid = uid + 'b';   /* blur filter for glow */
    var eid = uid + 'e';   /* edge glow filter */

    /* ── Shared defs ── */
    var defs =
      '<defs>'
      /* soft blur for ambient glow */
      + '<filter id="' + bid + '" x="-40%" y="-40%" width="180%" height="180%">'
      + '<feGaussianBlur stdDeviation="6"/></filter>'

      /* edge glow filter — sharp + blurred merge for lit glass rim */
      + '<filter id="' + eid + '" x="-25%" y="-25%" width="150%" height="150%">'
      + '<feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur"/>'
      + '<feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>'
      + '</filter>'

      /* glass sheen — top catch-light, then nearly clear */
      + '<linearGradient id="' + gid + '" x1="0" y1="0" x2="0.3" y2="1">'
      + '<stop offset="0%"   stop-color="rgba(255,255,255,0.42)"/>'
      + '<stop offset="18%"  stop-color="rgba(200,235,255,0.10)"/>'
      + '<stop offset="60%"  stop-color="rgba(150,210,240,0.03)"/>'
      + '<stop offset="100%" stop-color="rgba(80,150,200,0.18)"/>'
      + '</linearGradient>'

      /* dark navy radial — gives crystal its "deep" look, bright center */
      + '<radialGradient id="' + rid + '" cx="50%" cy="42%" r="58%">'
      + '<stop offset="0%"   stop-color="rgba(180,220,255,0.12)"/>'
      + '<stop offset="50%"  stop-color="rgba(20,50,90,0.22)"/>'
      + '<stop offset="100%" stop-color="rgba(0,15,40,0.55)"/>'
      + '</radialGradient>'

      /* dark fill for crystal body background — navy/smoke */
      + '<radialGradient id="' + uid + 'dark" cx="50%" cy="50%" r="60%">'
      + '<stop offset="0%"   stop-color="rgba(30,55,100,0.75)"/>'
      + '<stop offset="100%" stop-color="rgba(5,10,25,0.92)"/>'
      + '</radialGradient>';

    /* clip path — glass-frame uses inner rect, others use shape path */
    var fw = 22;
    if (shape === 'glass-frame') {
      defs += '<clipPath id="' + cid + '"><rect x="' + fw + '" y="' + fw + '" width="' + (W - fw*2) + '" height="' + (H - fw*2) + '" rx="2"/></clipPath>';
    } else {
      defs += '<clipPath id="' + cid + '"><path d="' + def.clip + '"/></clipPath>';
    }
    defs += '</defs>';

    var inner = '';

    /* ── SPARKLE helper ── */
    function sparkle(x, y, r) {
      return '<g transform="translate(' + x + ',' + y + ')" opacity="0.92">'
        + '<line x1="0" y1="-' + (r * 2.2) + '" x2="0" y2="' + (r * 2.2) + '" stroke="white" stroke-width="' + (r * 0.55) + '" stroke-linecap="round"/>'
        + '<line x1="-' + (r * 2.2) + '" y1="0" x2="' + (r * 2.2) + '" y2="0" stroke="white" stroke-width="' + (r * 0.55) + '" stroke-linecap="round"/>'
        + '<line x1="-' + (r * 1.4) + '" y1="-' + (r * 1.4) + '" x2="' + (r * 1.4) + '" y2="' + (r * 1.4) + '" stroke="white" stroke-width="' + (r * 0.35) + '" stroke-linecap="round"/>'
        + '<line x1="' + (r * 1.4) + '" y1="-' + (r * 1.4) + '" x2="-' + (r * 1.4) + '" y2="' + (r * 1.4) + '" stroke="white" stroke-width="' + (r * 0.35) + '" stroke-linecap="round"/>'
        + '<circle cx="0" cy="0" r="' + r + '" fill="white"/>'
        + '</g>';
    }

    if (shape === 'glass-frame') {
      var iw = W - fw * 2, ih = H - fw * 2;
      var ix = fw, iy = fw;
      var did = uid + 'dark';

      /* ground shadow */
      inner += '<ellipse cx="' + (W/2) + '" cy="' + (H + 2) + '" rx="' + (W * 0.42) + '" ry="9" fill="rgba(0,0,0,0.6)"/>';

      /* ── outer frame ambient glow ── */
      inner += '<rect x="2" y="2" width="' + (W-4) + '" height="' + (H-4) + '" rx="10"'
        + ' fill="none" stroke="rgba(100,200,255,0.25)" stroke-width="14" filter="url(#' + bid + ')"/>';

      /* ── solid glass frame body (4 beveled sides drawn as trapezoids) ── */
      /* top bevel */
      inner += '<polygon points="0,0 ' + W + ',0 ' + (W-fw) + ',' + fw + ' ' + fw + ',' + fw + '"'
        + ' fill="rgba(160,220,255,0.28)"/>';
      /* bottom bevel */
      inner += '<polygon points="0,' + H + ' ' + W + ',' + H + ' ' + (W-fw) + ',' + (H-fw) + ' ' + fw + ',' + (H-fw) + '"'
        + ' fill="rgba(80,150,210,0.22)"/>';
      /* left bevel */
      inner += '<polygon points="0,0 ' + fw + ',' + fw + ' ' + fw + ',' + (H-fw) + ' 0,' + H + '"'
        + ' fill="rgba(120,190,240,0.22)"/>';
      /* right bevel */
      inner += '<polygon points="' + W + ',0 ' + (W-fw) + ',' + fw + ' ' + (W-fw) + ',' + (H-fw) + ' ' + W + ',' + H + '"'
        + ' fill="rgba(100,170,220,0.18)"/>';

      /* ── outer frame edge lines (bright rims) ── */
      /* top-left to top-right outer rim */
      inner += '<line x1="0" y1="0" x2="' + W + '" y2="0" stroke="rgba(220,245,255,0.95)" stroke-width="1.5"/>';
      inner += '<line x1="0" y1="0" x2="0" y2="' + H + '" stroke="rgba(200,235,255,0.85)" stroke-width="1.5"/>';
      inner += '<line x1="' + W + '" y1="0" x2="' + W + '" y2="' + H + '" stroke="rgba(160,210,240,0.55)" stroke-width="1"/>';
      inner += '<line x1="0" y1="' + H + '" x2="' + W + '" y2="' + H + '" stroke="rgba(140,195,230,0.45)" stroke-width="1"/>';
      /* inner bevel rim lines */
      inner += '<rect x="' + fw + '" y="' + fw + '" width="' + iw + '" height="' + ih + '"'
        + ' fill="none" stroke="rgba(255,255,255,0.55)" stroke-width="1.2"/>';

      /* ── dark interior (crystal depth) ── */
      inner += '<rect x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih + '"'
        + ' fill="url(#' + did + ')"/>';

      /* ── photo inside, clipped ── */
      var px = crystalState._panX, py = crystalState._panY, ps = crystalState._scale;
      var cx = ix + iw / 2, cy = iy + ih / 2;
      inner += '<g id="zkk-photo-layer" clip-path="url(#' + cid + ')" style="transform-box:fill-box">'
        + '<image href="' + photoSrc + '" x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih
        + '" preserveAspectRatio="xMidYMid slice"'
        + ' transform="translate(' + px + ',' + py + ') scale(' + ps + ')"'
        + ' transform-origin="' + cx + ' ' + cy + '"'
        + '/>'
        + '</g>';

      /* ── glass overlays on photo ── */
      inner += '<rect x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih + '" fill="url(#' + rid + ')"/>';
      inner += '<rect x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih + '" fill="url(#' + gid + ')"/>';

      /* ── top catch-light streak across frame top ── */
      inner += '<path d="M8 2 C' + (W*0.3) + ' 0 ' + (W*0.7) + ' 0 ' + (W-8) + ' 2"'
        + ' stroke="rgba(255,255,255,0.75)" stroke-width="2.5" fill="none" stroke-linecap="round"/>';
      /* left edge catch */
      inner += '<path d="M1 6 L1 ' + (H*0.55) + '"'
        + ' stroke="rgba(255,255,255,0.45)" stroke-width="1.5" fill="none" stroke-linecap="round"/>';

      /* ── diagonal bevel corner lines ── */
      inner += '<line x1="0" y1="0" x2="' + fw + '" y2="' + fw + '" stroke="rgba(255,255,255,0.7)" stroke-width="1.5"/>';
      inner += '<line x1="' + W + '" y1="0" x2="' + (W-fw) + '" y2="' + fw + '" stroke="rgba(255,255,255,0.5)" stroke-width="1.2"/>';
      inner += '<line x1="0" y1="' + H + '" x2="' + fw + '" y2="' + (H-fw) + '" stroke="rgba(255,255,255,0.35)" stroke-width="1"/>';
      inner += '<line x1="' + W + '" y1="' + H + '" x2="' + (W-fw) + '" y2="' + (H-fw) + '" stroke="rgba(255,255,255,0.25)" stroke-width="1"/>';

      /* sparkles at corners */
      inner += sparkle(W - 10, 8, 5);
      inner += sparkle(8, H - 10, 3.5);
      inner += sparkle(W - 8, H - 8, 3);

    } else {
      var clipPath = def.clip;

      /* dark base/stand shadow */
      inner += '<ellipse cx="' + (W/2) + '" cy="' + (H - 4) + '" rx="' + (W * 0.32) + '" ry="9" fill="rgba(0,0,0,0.55)"/>';

      /* outer crystal glow (blurred shape behind) */
      inner += '<path d="' + clipPath + '" fill="rgba(80,160,220,0.32)" filter="url(#' + bid + ')"/>';

      /* crystal dark navy body — gives depth */
      inner += '<path d="' + clipPath + '" fill="url(#' + uid + 'dark)"/>';

      /* ── PHOTO — grayscale, clipped to shape, pan/zoom transform ── */
      var px = crystalState._panX, py = crystalState._panY, ps = crystalState._scale;
      var cx = W / 2, cy = H / 2;
      inner += '<g id="zkk-photo-layer" clip-path="url(#' + cid + ')" style="transform-box:fill-box">'
        + '<image href="' + photoSrc + '" x="0" y="0" width="' + W + '" height="' + H
        + '" preserveAspectRatio="xMidYMid slice"'
        + ' transform="translate(' + px + ',' + py + ') scale(' + ps + ')"'
        + ' transform-origin="' + cx + ' ' + cy + '"'
        + '/>'
        + '</g>';

      /* facet lines for diamond + iceberg */
      if ((shape === 'diamond' || shape === 'iceberg') && def.facet) {
        inner += '<path d="' + def.facet + '" fill="none" stroke="rgba(200,235,255,0.5)" stroke-width="2"/>';
      }

      /* ── GLASS OVERLAYS ── */
      /* radial depth glow */
      inner += '<path d="' + clipPath + '" fill="url(#' + rid + ')"/>';
      /* top-to-bottom sheen */
      inner += '<path d="' + clipPath + '" fill="url(#' + gid + ')"/>';

      /* ── CRYSTAL EDGE — thick glowing border ── */
      /* outer glow ring */
      inner += '<path d="' + clipPath + '" fill="none" stroke="rgba(140,210,245,0.5)" stroke-width="10" stroke-linejoin="round" filter="url(#' + bid + ')"/>';
      /* bright inner edge */
      inner += '<path d="' + clipPath + '" fill="none" stroke="rgba(210,240,255,0.95)" stroke-width="3" stroke-linejoin="round"/>';
      /* thin sharp inner edge */
      inner += '<path d="' + clipPath + '" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="1" stroke-linejoin="round"/>';

      /* ── HIGHLIGHT STREAK top-left ── */
      if (def.hl) {
        inner += '<path d="' + def.hl + '" fill="none" stroke="rgba(255,255,255,0.85)" stroke-width="5" stroke-linecap="round"/>';
        inner += '<path d="' + def.hl + '" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="10" stroke-linecap="round" filter="url(#' + bid + ')"/>';
      }

      /* ── SPARKLES ── positioned per shape */
      var sp = {
        heart:      [{ x: W - 22, y: 16, r: 7 }, { x: 18, y: H - 22, r: 4.5 }],
        rectangle:  [{ x: W - 16, y: 14, r: 6 }, { x: 16, y: H - 16, r: 4 }],
        oval:       [{ x: W - 20, y: 18, r: 6 }, { x: 22, y: H - 24, r: 4 }],
        star:       [{ x: W - 18, y: 18, r: 6 }, { x: 22, y: H - 22, r: 4 }],
        diamond:    [{ x: W - 20, y: 18, r: 6 }, { x: 22, y: H/2 - 10, r: 4 }],
        cube:       [{ x: W - 22, y: 16, r: 6 }, { x: 14, y: H - 20, r: 4 }],
        iceberg:    [{ x: W - 22, y: 16, r: 6 }, { x: 18, y: H - 30, r: 4 }],
        notch:      [{ x: W - 30, y: 20, r: 6 }, { x: 22, y: H - 24, r: 4 }]
      };
      (sp[shape] || []).forEach(function (s) { inner += sparkle(s.x, s.y, s.r); });
    }

    return (
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + def.vb + '" role="img" aria-label="Crystal preview">'
      + defs
      + inner
      + '</svg>'
    );
  }

  /* ── Async wrapper: converts photo to grayscale then builds SVG ── */
  function buildCrystalSVGAsync(dataUrl, shape, callback) {
    var def = CRYSTAL[shape];
    if (!def) { callback(''); return; }
    var vbParts = def.vb.split(' ');
    var W = parseInt(vbParts[2], 10);
    var H = parseInt(vbParts[3], 10);

    var img = new Image();
    img.onload = function () {
      var grayUrl = toGrayscaleDataUrl(img, W * 2, H * 2);
      callback(buildCrystalSVG(dataUrl, shape, '3d', grayUrl));
    };
    img.onerror = function () {
      callback(buildCrystalSVG(dataUrl, shape, '3d', null));
    };
    img.src = dataUrl;
  }

  /* ═══════════════════════════════════════════════════════════════
     SVG PREVIEW — CANVAS (multi-panel layout)
  ═══════════════════════════════════════════════════════════════ */
  function buildCanvasSVG(dataUrl, orientation, panels, style) {
    var gap    = 8;
    var frameW = style === 'floating-frame' ? 5 : 0;
    var rects  = [];
    var svgW, svgH;

    if (orientation === 'vertical') {
      svgW = 220;
      svgH = 300;
      var ph = (svgH - (panels - 1) * gap) / panels;
      for (var vi = 0; vi < panels; vi++) {
        rects.push({ x: 0, y: Math.round(vi * (ph + gap)), w: svgW, h: Math.round(ph) });
      }
    } else if (orientation === 'square') {
      svgW = 300;
      var pw = (svgW - (panels - 1) * gap) / panels;
      svgH = Math.round(pw);
      for (var si = 0; si < panels; si++) {
        rects.push({ x: Math.round(si * (pw + gap)), y: 0, w: Math.round(pw), h: svgH });
      }
    } else { /* horizontal */
      svgW = 380;
      svgH = 220;
      var pw = (svgW - (panels - 1) * gap) / panels;
      for (var hi = 0; hi < panels; hi++) {
        rects.push({ x: Math.round(hi * (pw + gap)), y: 0, w: Math.round(pw), h: svgH });
      }
    }

    var uid = 'cv' + Math.random().toString(36).slice(2, 7);
    var defs = '';
    var body = '';

    rects.forEach(function (r, idx) {
      var cid  = uid + 'p' + idx;
      var rx   = style === 'floating-frame' ? 2 : 3;
      var iX   = r.x + frameW;
      var iY   = r.y + frameW;
      var iW   = r.w - frameW * 2;
      var iH   = r.h - frameW * 2;

      defs += '<clipPath id="' + cid + '"><rect x="' + iX + '" y="' + iY + '" width="' + iW + '" height="' + iH + '" rx="' + rx + '"/></clipPath>';

      /* frame background */
      var frameFill = style === 'floating-frame' ? '#1a1a1a' : '#e8e0d8';
      body += '<rect x="' + r.x + '" y="' + r.y + '" width="' + r.w + '" height="' + r.h + '" fill="' + frameFill + '" rx="' + (style === 'floating-frame' ? 4 : 3) + '"/>';

      /* photo — same full-SVG-area image, each panel's clipPath shows its slice */
      body += '<image href="' + dataUrl + '" x="0" y="0" width="' + svgW + '" height="' + svgH + '" preserveAspectRatio="xMidYMid slice" clip-path="url(#' + cid + ')"/>';

      /* subtle panel border */
      var borderC = style === 'floating-frame' ? '#111' : '#cfcbc3';
      var bw      = style === 'floating-frame' ? 2 : 1;
      body += '<rect x="' + (r.x + 0.5) + '" y="' + (r.y + 0.5) + '" width="' + (r.w - 1) + '" height="' + (r.h - 1) + '" fill="none" stroke="' + borderC + '" stroke-width="' + bw + '" rx="' + (style === 'floating-frame' ? 4 : 3) + '"/>';
    });

    return (
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + svgW + ' ' + svgH + '" role="img" aria-label="Canvas preview">'
      + '<defs>' + defs + '</defs>'
      + body
      + '</svg>'
    );
  }

  /* ═══════════════════════════════════════════════════════════════
     FILE UPLOAD HANDLING
  ═══════════════════════════════════════════════════════════════ */
  function readFile(file, onLoad) {
    if (!file || !file.type.startsWith('image/')) return;
    var reader = new FileReader();
    reader.onload = function (e) { onLoad(e.target.result); };
    reader.readAsDataURL(file);
  }

  function resetUploadUI(type) {
    var uploadZone  = document.getElementById('zkk-' + type + '-upload-zone');
    var previewZone = document.getElementById('zkk-' + type + '-preview-zone');
    var fileInput   = document.getElementById('zkk-' + type + '-file');
    var svgWrap     = document.getElementById('zkk-' + type + '-svg-wrap');
    if (uploadZone)  uploadZone.removeAttribute('hidden');
    if (previewZone) previewZone.setAttribute('hidden', '');
    if (fileInput)   fileInput.value = '';
    if (svgWrap)     svgWrap.innerHTML = '';
  }

  /* ═══════════════════════════════════════════════════════════════
     SUMMARY CHIPS  (shared helper)
  ═══════════════════════════════════════════════════════════════ */
  function makeSummaryChips(el, items, orderBtn, baseUrl, params) {
    if (!el) return;
    el.innerHTML = '';
    var checkSvg = '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true" width="13" height="13"><path d="M2.5 7l3.5 3.5 5.5-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    items.forEach(function (label) {
      if (!label) return;
      var chip = document.createElement('span');
      chip.className = 'zkk-summary__chip';
      chip.innerHTML = checkSvg + label;
      el.appendChild(chip);
    });
    /* store customisation params on the button for addToCart to read */
    if (orderBtn) {
      orderBtn.setAttribute('data-cart-props', JSON.stringify(params || {}));
    }
  }

  /* ═══════════════════════════════════════════════════════════════
     ADD TO CART  (AJAX)
  ═══════════════════════════════════════════════════════════════ */
  function addToCart(btn, variantId, properties, extraItems) {
    if (!variantId) {
      window.location.href = btn.getAttribute('data-base-url') || '/cart';
      return;
    }
    var label = btn.querySelector('.zkk-btn-label');
    var icon  = btn.querySelector('.zkk-cart-icon');

    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    var allItems = [{ id: parseInt(variantId, 10), quantity: 1, properties: properties || {} }];
    if (extraItems && extraItems.length) {
      extraItems.forEach(function (it) { allItems.push(it); });
    }
    var body = { items: allItems };

    /* Request Shopify to re-render cart sections so notification + icon bubble update */
    var sectionsToRender = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    var bodyWithSections = Object.assign({}, body, { sections: sectionsToRender, sections_url: window.location.pathname });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(bodyWithSections)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart_error');
      return res.json();
    })
    .then(function (data) {
      /* persist photo so cart page thumbnail works */
      var price = btn.getAttribute('data-custom-price');
      var lineKey = (data && data.items && data.items[0]) ? String(data.items[0].key) : null;
      if (lineKey) {
        try {
          var photo = localStorage.getItem('zkk_pending_photo') || null;
          var store = JSON.parse(localStorage.getItem('zkk_cart_items') || '{}');
          store[lineKey] = { photo: photo, price: price };
          localStorage.setItem('zkk_cart_items', JSON.stringify(store));
          localStorage.removeItem('zkk_pending_photo');
        } catch (e) {}
      }

      /* close the modal if open */
      var modal = btn.closest('.zkk-overlay');
      if (modal) closeModal(modal);

      /* reset button */
      if (label) label.textContent = 'Add To Cart';
      if (icon)  icon.style.display = '';
      btn.disabled = false;
      btn.classList.remove('zkk-btn-cta--success');

      /* trigger Dawn's native cart notification + update cart icon count */
      var cartNotification = document.querySelector('cart-notification');
      var cartDrawer       = document.querySelector('cart-drawer');
      if (data.sections) {
        if (cartNotification && typeof cartNotification.renderContents === 'function') {
          cartNotification.renderContents({ key: lineKey, sections: data.sections });
        } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ key: lineKey, sections: data.sections });
        } else {
          /* fallback: just update the cart icon bubble count */
          var bubbleEl = document.getElementById('cart-icon-bubble');
          if (bubbleEl && data.sections['cart-icon-bubble']) {
            var parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var inner  = parsed.querySelector('.shopify-section');
            if (inner) bubbleEl.innerHTML = inner.innerHTML;
          }
        }
      }
    })
    .catch(function () {
      if (label) label.textContent = 'Error — retry';
      btn.classList.add('zkk-btn-cta--error');
      btn.disabled = false;
      setTimeout(function () {
        btn.classList.remove('zkk-btn-cta--error');
        if (label) label.textContent = 'Add To Cart';
        if (icon)  icon.style.display = '';
      }, 2500);
    });
  }

  /* Upload base64 image to Cloudinary, returns Promise<url|null> */
  function uploadToImgBB(dataUrl) {
    return new Promise(function (resolve) {
      try {
        var cloudName   = window.CLOUDINARY_CLOUD_NAME;
        var uploadPreset = window.CLOUDINARY_UPLOAD_PRESET;
        if (!cloudName || !uploadPreset) return resolve(null);
        var base64 = dataUrl.split(',')[1];
        if (!base64) return resolve(null);
        var fd = new FormData();
        fd.append('file', 'data:image/jpeg;base64,' + base64);
        fd.append('upload_preset', uploadPreset);
        fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/image/upload', { method: 'POST', body: fd })
          .then(function (r) { return r.json(); })
          .then(function (d) { resolve((d && d.secure_url) ? d.secure_url : null); })
          .catch(function () { resolve(null); });
      } catch (e) { resolve(null); }
    });
  }

  function wireCartButton(btnId) {
    var btn = document.getElementById(btnId);
    if (!btn) return;
    btn.addEventListener('click', function () {
      /* Canvas: require style + layout + size before proceeding */
      if (btnId === 'zkk-canvas-order-btn') {
        if (!canvasState.style)  { alert('Please select a canvas style.');       return; }
        if (!canvasState.size)   { alert('Please select a size.');               return; }
      }

      var variantId   = btn.getAttribute('data-variant-id');
      var rawProps    = btn.getAttribute('data-cart-props');
      var properties  = {};
      try { properties = JSON.parse(rawProps || '{}'); } catch (e) {}
      var productType = btn.getAttribute('data-product-type');
      if (productType) properties['Product Type'] = productType;

      /* get the original uploaded photo dataUrl */
      var dataUrl = null;
      if (btnId === 'zkk-crystal-order-btn') {
        dataUrl = crystalState._lastDataUrl || null;
      } else {
        var svgWrap = document.getElementById('zkk-canvas-svg-wrap');
        dataUrl = svgWrap && svgWrap.getAttribute('data-last-url');
      }

      /* collect addon items for crystal */
      var extraItems = [];
      if (btnId === 'zkk-crystal-order-btn') {
        if (!variantId) { alert('Please select a valid crystal size.'); return; }
        if (typeof window.getCrystalAddonItems === 'function') {
          extraItems = window.getCrystalAddonItems();
        }
      }

      var label = btn.querySelector('.zkk-btn-label');
      if (label) label.textContent = 'Uploading…';
      btn.disabled = true;

      if (dataUrl) {
        /* Upload photo to Cloudinary silently → store public URL as line item property */
        uploadToImgBB(dataUrl).then(function (photoUrl) {
          if (photoUrl) {
            properties['_Custom photo'] = photoUrl;
            /* also persist for cart page thumbnail display */
            try { localStorage.setItem('zkk_pending_photo', photoUrl); } catch (e) {}
            if (label) label.textContent = 'Add To Cart';
            btn.disabled = false;
            addToCart(btn, variantId, properties, extraItems);
          } else {
            /* Upload failed — do not silently place the order without the customer's photo */
            if (label) label.textContent = 'Photo upload failed — retry';
            btn.classList.add('zkk-btn-cta--error');
            btn.disabled = false;
            setTimeout(function () {
              btn.classList.remove('zkk-btn-cta--error');
              if (label) label.textContent = 'Add To Cart';
            }, 3000);
          }
        });
      } else {
        if (label) label.textContent = 'Add To Cart';
        btn.disabled = false;
        addToCart(btn, variantId, properties, extraItems);
      }
    });
  }

  /* ═══════════════════════════════════════════════════════════════
     CANVAS WIZARD
  ═══════════════════════════════════════════════════════════════ */
  function resetCanvas() {
    canvasState.step        = 1;
    canvasState.style       = null;
    canvasState.orientation = 'horizontal';
    canvasState.layout      = 1;
    canvasState.size        = null;

    var modal = document.querySelector('[data-zkk-inline="canvas"]') || document.getElementById('zkk-canvas-modal');
    if (!modal) return;

    modal.querySelectorAll('.zkk-canvas-style-card, .zkk-layout-option, .zkk-size-option').forEach(function (el) {
      el.classList.remove('is-selected');
      el.setAttribute('aria-pressed', 'false');
    });
    modal.querySelectorAll('.zkk-canvas-tab').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-orient') === 'horizontal');
      t.setAttribute('aria-selected', t.getAttribute('data-orient') === 'horizontal' ? 'true' : 'false');
    });

    var uploadZone  = document.getElementById('zkk-canvas-upload-zone');
    var previewZone = document.getElementById('zkk-canvas-preview-zone');
    var fileInput   = document.getElementById('zkk-canvas-file');
    var svgWrap     = document.getElementById('zkk-canvas-svg-wrap');
    var changeBtn   = document.getElementById('zkk-canvas-change-photo');
    if (uploadZone)  uploadZone.removeAttribute('hidden');
    if (previewZone) previewZone.setAttribute('hidden', '');
    if (fileInput)   fileInput.value = '';
    if (svgWrap)     svgWrap.innerHTML = '';
    if (changeBtn)   changeBtn.style.display = 'none';

    updateCanvasSummary();
    buildLayoutGrid(canvasState.orientation);
    buildSizeGrid();
  }

  function buildLayoutGrid(orient) {
    var grid = document.getElementById('zkk-canvas-layout-grid');
    if (!grid) return;
    grid.innerHTML = '';
    [1, 2, 3, 4, 5].forEach(function (n) {
      var btn = document.createElement('button');
      btn.className = 'zkk-layout-option';
      btn.setAttribute('data-panels', n);
      btn.setAttribute('aria-pressed', 'false');

      var preview = document.createElement('div');
      preview.className = 'zkk-layout-preview' + (orient === 'vertical' ? ' zkk-layout-preview--vertical' : '');
      for (var i = 0; i < n; i++) preview.appendChild(document.createElement('div'));

      var lbl = document.createElement('span');
      lbl.textContent = LAYOUT_LABELS[n];

      btn.appendChild(preview);
      btn.appendChild(lbl);
      grid.appendChild(btn);

      btn.addEventListener('click', function () {
        grid.querySelectorAll('.zkk-layout-option').forEach(function (b) {
          b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
        canvasState.layout = n;
        canvasState.size   = null;
        buildSizeGrid();
        updateCanvasSummary();
        refreshCanvasPreview();
      });
    });
  }

  function buildSizeGrid() {
    /* If canvas-page.js has registered a fixed-size override, use it */
    if (typeof window._buildSizeGridOverride === 'function') {
      window._buildSizeGridOverride();
      return;
    }

    var container = document.getElementById('zkk-canvas-sizes');
    if (!container) return;
    container.innerHTML = '';

    var orient = canvasState.orientation || 'horizontal';
    var count  = canvasState.layout || 1;
    var sizes  = (CANVAS_SIZES[orient] && CANVAS_SIZES[orient][count]) || CANVAS_SIZES.horizontal[1];

    sizes.forEach(function (s) {
      var btn = document.createElement('button');
      btn.className = 'zkk-size-option';
      btn.setAttribute('data-size', s.dim);
      btn.setAttribute('aria-pressed', 'false');

      var badge = document.createElement('span');
      badge.className = 'zkk-size-option__badge' + (s.pop ? ' zkk-badge--pop' : '');
      badge.textContent = s.pop ? 'Most Popular' : 'Total size';

      var dim = document.createElement('span');
      dim.className = 'zkk-size-option__dim';
      dim.textContent = s.dim;

      var note = document.createElement('span');
      note.className = 'zkk-size-option__note';
      note.textContent = s.note;

      btn.appendChild(badge); btn.appendChild(dim); btn.appendChild(note);
      container.appendChild(btn);

      btn.addEventListener('click', function () {
        container.querySelectorAll('.zkk-size-option').forEach(function (b) {
          b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
        canvasState.size = s.dim;
        updateCanvasSummary();
        refreshCanvasPreview();
      });
    });

    var sub = document.getElementById('zkk-canvas-size-subtitle');
    if (sub && canvasState.layout) {
      var oLbl = { horizontal:'Horizontal', square:'Square', vertical:'Vertical' }[orient] || '';
      sub.textContent = oLbl + ' · ' + (LAYOUT_LABELS[count] || count + '-Panel');
    } else if (sub) {
      sub.textContent = '';
    }
  }

  function updateCanvasSummary() {
    var STYLE_MAP = { 'gallery-wrap': 'Gallery Wrap', 'floating-frame': 'Floating Frame', 'standard': 'Standard Print' };
    var oMap      = { horizontal: 'Horizontal', square: 'Square', vertical: 'Vertical' };
    var items = [];
    if (canvasState.style)  items.push(STYLE_MAP[canvasState.style]);
    if (canvasState.layout) items.push((oMap[canvasState.orientation] || '') + ' · ' + (LAYOUT_LABELS[canvasState.layout] || '') + ' Panel');
    if (canvasState.size)   items.push(canvasState.size);
    var el     = document.getElementById('zkk-canvas-summary');
    var btn    = document.getElementById('zkk-canvas-order-btn');
    var base   = btn && btn.getAttribute('data-base-url');
    /* look up price — first try canvasVariants (fixed 3-size mode), then CANVAS_SIZES */
    var price = null;
    if (canvasState.size && window.canvasVariants) {
      var cvKeys = Object.keys(window.canvasVariants);
      for (var ci = 0; ci < cvKeys.length; ci++) {
        var cv = window.canvasVariants[cvKeys[ci]];
        if (cv.dim === canvasState.size) { price = cv.price; break; }
      }
    }
    if (price === null && canvasState.size) {
      var group = (CANVAS_SIZES[canvasState.orientation] || {})[canvasState.layout || 1] || [];
      for (var i = 0; i < group.length; i++) {
        if (group[i].dim === canvasState.size) { price = group[i].price; break; }
      }
    }
    if (btn && price) btn.setAttribute('data-custom-price', String(price));

    var params = {
      'Canvas Style': canvasState.style ? { 'gallery-wrap': 'Gallery Wrap', 'floating-frame': 'Floating Frame', 'standard': 'Standard Print' }[canvasState.style] || canvasState.style : '',
      'Orientation':  { horizontal: 'Horizontal', square: 'Square', vertical: 'Vertical' }[canvasState.orientation] || canvasState.orientation,
      'Layout':       canvasState.layout ? (LAYOUT_LABELS[canvasState.layout] || canvasState.layout + '-Panel') : '',
      'Size':         canvasState.size || '',
      '_price':       price ? '$' + price + '.00' : ''
    };
    makeSummaryChips(el, items, btn, base, params);
  }

  function refreshCanvasPreview() {
    var svgWrap = document.getElementById('zkk-canvas-svg-wrap');
    if (!svgWrap) return;
    var previewZone = document.getElementById('zkk-canvas-preview-zone');
    if (!previewZone || previewZone.hasAttribute('hidden')) return;
    var fileInput = document.getElementById('zkk-canvas-file');
    /* re-use last dataUrl stored on svgWrap */
    var dataUrl = svgWrap.getAttribute('data-last-url');
    if (!dataUrl) return;
    var svg = buildCanvasSVG(dataUrl, canvasState.orientation, canvasState.layout || 1, canvasState.style || 'gallery-wrap');
    if (svg) svgWrap.innerHTML = svg;
  }

  function initCanvas() {
    var modal = document.querySelector('[data-zkk-inline="canvas"]') || document.getElementById('zkk-canvas-modal');
    if (!modal) return;

    /* Style cards */
    var styleGrid = document.getElementById('zkk-canvas-style-grid');
    if (styleGrid) {
      styleGrid.addEventListener('click', function (e) {
        var card = e.target.closest('.zkk-canvas-style-card');
        if (!card) return;
        styleGrid.querySelectorAll('.zkk-canvas-style-card').forEach(function (b) {
          b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected'); card.setAttribute('aria-pressed', 'true');
        canvasState.style = card.getAttribute('data-value');
        updateCanvasSummary();
        refreshCanvasPreview();
      });
    }

    /* Orientation tabs */
    modal.querySelectorAll('.zkk-canvas-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        modal.querySelectorAll('.zkk-canvas-tab').forEach(function (t) {
          t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
        canvasState.orientation = tab.getAttribute('data-orient');
        canvasState.layout = 1;
        canvasState.size   = null;
        buildLayoutGrid(canvasState.orientation);
        buildSizeGrid();
        updateCanvasSummary();
        refreshCanvasPreview();
      });
    });

    buildLayoutGrid(canvasState.orientation);
    buildSizeGrid();

    /* File upload — inline (mirrors crystal) */
    var fileInput   = document.getElementById('zkk-canvas-file');
    var uploadZone  = document.getElementById('zkk-canvas-upload-zone');
    var previewZone = document.getElementById('zkk-canvas-preview-zone');
    var svgWrap     = document.getElementById('zkk-canvas-svg-wrap');
    var dropArea    = document.getElementById('zkk-canvas-drop-area');
    var changeBtn   = document.getElementById('zkk-canvas-change-photo');

    function showCanvasPreview(dataUrl) {
      var svg = buildCanvasSVG(dataUrl, canvasState.orientation, canvasState.layout || 1, canvasState.style || 'gallery-wrap');
      if (!svg) return;
      svgWrap.setAttribute('data-last-url', dataUrl);
      svgWrap.innerHTML = svg;
      uploadZone.setAttribute('hidden', '');
      previewZone.removeAttribute('hidden');
      if (changeBtn) changeBtn.style.display = '';
      updateCanvasSummary();
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files[0]) readFile(fileInput.files[0], showCanvasPreview);
      });
    }
    if (dropArea) {
      dropArea.addEventListener('dragover', function (e) { e.preventDefault(); uploadZone && uploadZone.classList.add('is-dragover'); });
      dropArea.addEventListener('dragleave', function () { uploadZone && uploadZone.classList.remove('is-dragover'); });
      dropArea.addEventListener('drop', function (e) {
        e.preventDefault();
        uploadZone && uploadZone.classList.remove('is-dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) readFile(file, showCanvasPreview);
      });
    }
  }

  /* ═══════════════════════════════════════════════════════════════
     CRYSTAL — SINGLE-PAGE (no wizard steps)
  ═══════════════════════════════════════════════════════════════ */
  function resetCrystal() {
    crystalState.step         = 1;
    crystalState.shape        = null;
    crystalState.size         = null;
    crystalState.effect       = '3d';
    crystalState._lastDataUrl = null;
    crystalState._panX        = 0;
    crystalState._panY        = 0;
    crystalState._scale       = 1;
    var zc = document.getElementById('zkk-zoom-controls');
    if (zc) zc.remove();

    var modal = document.querySelector('[data-zkk-inline="crystal"]') || document.getElementById('zkk-crystal-modal');
    if (!modal) return;

    modal.querySelectorAll('.zkk-product-card, .zkk-size-pill').forEach(function (el) {
      el.classList.remove('is-selected'); el.setAttribute('aria-pressed', 'false');
    });

    /* reset upload + preview */
    var uploadZone  = document.getElementById('zkk-crystal-upload-zone');
    var previewZone = document.getElementById('zkk-crystal-preview-zone');
    var fileInput   = document.getElementById('zkk-crystal-file');
    var svgWrap     = document.getElementById('zkk-crystal-svg-wrap');
    var changeBtn   = document.getElementById('zkk-crystal-change-photo');
    if (uploadZone)  uploadZone.removeAttribute('hidden');
    if (previewZone) previewZone.setAttribute('hidden', '');
    if (fileInput)   fileInput.value = '';
    if (svgWrap)     svgWrap.innerHTML = '';
    if (changeBtn)   changeBtn.style.display = 'none';

    updateCrystalSummary();
  }

  function updateCrystalSummary() {
    var SHAPE_MAP = { heart:'Heart', rectangle:'Rectangle', oval:'Oval', star:'Star', diamond:'Prestige', 'glass-frame':'Glass Frame', iceberg:'Iceberg', cube:'Cube' };
    var SIZE_MAP  = { small:'3″ \xd7 4″', medium:'4″ \xd7 6″', large:'6″ \xd7 8″', xlarge:'8″ \xd7 10″' };
    var el   = document.getElementById('zkk-crystal-summary');
    var btn  = document.getElementById('zkk-crystal-order-btn');
    var base = btn && btn.getAttribute('data-base-url');

    var items = [];
    if (crystalState.shape) items.push((SHAPE_MAP[crystalState.shape] || crystalState.shape) + ' Crystal');
    if (crystalState.size)  items.push(SIZE_MAP[crystalState.size] || crystalState.size);
    if (items.length)       items.push('3D Laser Engraved');

    var SHAPE_LABEL = crystalState.shape ? (SHAPE_MAP[crystalState.shape] || crystalState.shape) : '';
    var SIZE_LABEL  = crystalState.size  ? (SIZE_MAP[crystalState.size]   || crystalState.size)  : '';
    var price = crystalState.size ? (CRYSTAL_PRICES[crystalState.size] || null) : null;
    if (btn && price) btn.setAttribute('data-custom-price', String(price));
    var params = {
      'Crystal Shape': SHAPE_LABEL,
      'Size':          SIZE_LABEL,
      'Effect':        '3D Laser Engraved',
      '_price':        price ? '$' + price + '.00' : ''
    };
    makeSummaryChips(el, items, btn, base, params);
  }

  function refreshCrystalPreview() {
    var svgWrap = document.getElementById('zkk-crystal-svg-wrap');
    if (!svgWrap || !crystalState.shape) return;
    var dataUrl = crystalState._lastDataUrl;
    if (!dataUrl) return;
    buildCrystalSVGAsync(dataUrl, crystalState.shape, function (svg) {
      if (!svg) return;
      svgWrap.innerHTML = svg;
      var photoLayer = svgWrap.querySelector('#zkk-photo-layer image');
      if (photoLayer) {
        photoLayer.setAttribute('transform', 'translate(' + crystalState._panX + ',' + crystalState._panY + ') scale(' + crystalState._scale + ')');
      }
    });
  }
  /* expose so crystal-page.js can trigger re-renders and summary updates */
  window.refreshCrystalPreview  = refreshCrystalPreview;
  window.updateCrystalSummary   = updateCrystalSummary;
  window.crystalState           = crystalState;

  /* expose so canvas-page.js orientation tabs can delegate */
  window.canvasState            = canvasState;
  window.buildLayoutGrid        = buildLayoutGrid;
  window.buildSizeGrid          = buildSizeGrid;
  window.updateCanvasSummary    = updateCanvasSummary;
  window.refreshCanvasPreview   = refreshCanvasPreview;

  function initCrystal() {
    var modal = document.querySelector('[data-zkk-inline="crystal"]') || document.getElementById('zkk-crystal-modal');
    if (!modal) return;

    /* On the dedicated page, crystal-page.js drives shape/size selection.
       Set defaults on crystalState so the first upload uses the right shape. */
    var isInlinePage = modal.hasAttribute('data-zkk-inline');
    if (isInlinePage) {
      crystalState.shape = crystalState.shape || 'rectangle';
      crystalState.size  = crystalState.size  || 'medium';
    }

    /* Shape cards — modal only (page uses cxp-shape-grid wired in crystal-page.js) */
    modal.querySelectorAll('#zkk-crystal-shape-grid .zkk-product-card').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.querySelectorAll('#zkk-crystal-shape-grid .zkk-product-card').forEach(function (b) {
          b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
        crystalState.shape = btn.getAttribute('data-value');
        updateCrystalSummary();
        refreshCrystalPreview();
      });
    });

    /* Size pills — modal only */
    modal.querySelectorAll('#zkk-crystal-size-pills .zkk-size-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.querySelectorAll('#zkk-crystal-size-pills .zkk-size-pill').forEach(function (b) {
          b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
        crystalState.size = btn.getAttribute('data-size');
        updateCrystalSummary();
      });
    });

    /* File upload — inline handler (not using setupUpload) */
    var fileInput   = document.getElementById('zkk-crystal-file');
    var uploadZone  = document.getElementById('zkk-crystal-upload-zone');
    var previewZone = document.getElementById('zkk-crystal-preview-zone');
    var svgWrap     = document.getElementById('zkk-crystal-svg-wrap');
    var dropArea    = document.getElementById('zkk-crystal-drop-area');
    var changeBtn   = document.getElementById('zkk-crystal-change-photo');

    function showCrystalPreview(dataUrl) {
      var shape = crystalState.shape || 'rectangle';
      crystalState._lastDataUrl = dataUrl;
      crystalState._panX = 0; crystalState._panY = 0; crystalState._scale = 1;
      buildCrystalSVGAsync(dataUrl, shape, function (svg) {
        if (!svg) return;
        svgWrap.innerHTML = svg;
        uploadZone.setAttribute('hidden', '');
        previewZone.removeAttribute('hidden');
        if (changeBtn) changeBtn.style.display = '';
        injectZoomControls();
        attachPanZoom();
      });
    }

    function injectZoomControls() {
      var existing = document.getElementById('zkk-zoom-controls');
      if (existing) existing.remove();
      var el = document.createElement('div');
      el.className = 'zkk-zoom-controls';
      el.id = 'zkk-zoom-controls';
      el.innerHTML =
        '<button class="zkk-zoom-btn" id="zkk-zoom-out" aria-label="Zoom out">−</button>'
        + '<button class="zkk-zoom-reset" id="zkk-zoom-reset" aria-label="Reset view">RESET</button>'
        + '<button class="zkk-zoom-btn" id="zkk-zoom-in" aria-label="Zoom in">+</button>';
      previewZone.appendChild(el);

      document.getElementById('zkk-zoom-in').addEventListener('click', function () {
        crystalState._scale = Math.min(3, crystalState._scale + 0.15);
        applyPanZoom();
      });
      document.getElementById('zkk-zoom-out').addEventListener('click', function () {
        crystalState._scale = Math.max(0.4, crystalState._scale - 0.15);
        applyPanZoom();
      });
      document.getElementById('zkk-zoom-reset').addEventListener('click', function () {
        crystalState._panX = 0; crystalState._panY = 0; crystalState._scale = 1;
        applyPanZoom();
      });
    }

    function applyPanZoom() {
      var photoLayer = svgWrap.querySelector('#zkk-photo-layer image');
      if (!photoLayer) { refreshCrystalPreview(); return; }
      var px = crystalState._panX, py = crystalState._panY, ps = crystalState._scale;
      photoLayer.setAttribute('transform', 'translate(' + px + ',' + py + ') scale(' + ps + ')');
    }

    function attachPanZoom() {
      /* mouse wheel zoom */
      svgWrap.addEventListener('wheel', function (e) {
        e.preventDefault();
        var delta = e.deltaY < 0 ? 0.1 : -0.1;
        crystalState._scale = Math.min(3, Math.max(0.4, crystalState._scale + delta));
        applyPanZoom();
      }, { passive: false });

      /* mouse drag pan */
      var dragging = false, startX = 0, startY = 0, origX = 0, origY = 0;
      svgWrap.addEventListener('mousedown', function (e) {
        dragging = true;
        startX = e.clientX; startY = e.clientY;
        origX = crystalState._panX; origY = crystalState._panY;
        svgWrap.classList.add('is-dragging');
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        /* SVG coordinate scale: viewBox / rendered px ratio */
        var svgEl = svgWrap.querySelector('svg');
        var ratio = svgEl ? (parseFloat(svgEl.getAttribute('viewBox').split(' ')[2]) / svgWrap.offsetWidth) : 1;
        crystalState._panX = origX + (e.clientX - startX) * ratio;
        crystalState._panY = origY + (e.clientY - startY) * ratio;
        applyPanZoom();
      });
      document.addEventListener('mouseup', function () {
        if (dragging) { dragging = false; svgWrap.classList.remove('is-dragging'); }
      });

      /* touch pan + pinch zoom */
      var lastTouches = null;
      svgWrap.addEventListener('touchstart', function (e) {
        lastTouches = e.touches;
        if (e.touches.length === 1) {
          startX = e.touches[0].clientX; startY = e.touches[0].clientY;
          origX = crystalState._panX; origY = crystalState._panY;
        }
        e.preventDefault();
      }, { passive: false });
      svgWrap.addEventListener('touchmove', function (e) {
        e.preventDefault();
        var svgEl = svgWrap.querySelector('svg');
        var ratio = svgEl ? (parseFloat(svgEl.getAttribute('viewBox').split(' ')[2]) / svgWrap.offsetWidth) : 1;
        if (e.touches.length === 1) {
          crystalState._panX = origX + (e.touches[0].clientX - startX) * ratio;
          crystalState._panY = origY + (e.touches[0].clientY - startY) * ratio;
          applyPanZoom();
        } else if (e.touches.length === 2 && lastTouches && lastTouches.length === 2) {
          var prevDist = Math.hypot(lastTouches[0].clientX - lastTouches[1].clientX, lastTouches[0].clientY - lastTouches[1].clientY);
          var newDist  = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
          var factor = newDist / prevDist;
          crystalState._scale = Math.min(3, Math.max(0.4, crystalState._scale * factor));
          applyPanZoom();
        }
        lastTouches = e.touches;
      }, { passive: false });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files[0]) readFile(fileInput.files[0], showCrystalPreview);
      });
    }

    if (dropArea) {
      dropArea.addEventListener('dragover', function (e) { e.preventDefault(); uploadZone && uploadZone.classList.add('is-dragover'); });
      dropArea.addEventListener('dragleave', function () { uploadZone && uploadZone.classList.remove('is-dragover'); });
      dropArea.addEventListener('drop', function (e) {
        e.preventDefault();
        uploadZone && uploadZone.classList.remove('is-dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) readFile(file, showCrystalPreview);
      });
    }
  }

  /* ═══════════════════════════════════════════════════════════════
     VARIANT ID RESOLVER
     Liquid all_products lookup can return empty on local dev.
     Fetch /products/{handle}.js as a fallback so it always works.
  ═══════════════════════════════════════════════════════════════ */
  var CANVAS_PRODUCT_HANDLE  = 'copy-of-100-dollar-bill-b-w-1';
  var CRYSTAL_PRODUCT_HANDLE = '3d-crystal-rectangle';

  function ensureVariantId(btnId) {
    var btn = document.getElementById(btnId);
    if (!btn) return;
    if (btn.getAttribute('data-variant-id')) return;
    var handle = btnId === 'zkk-crystal-order-btn' ? CRYSTAL_PRODUCT_HANDLE : CANVAS_PRODUCT_HANDLE;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variant = (p.variants || []).find(function (v) { return v.available; }) || p.variants[0];
        if (variant) {
          btn.setAttribute('data-variant-id', String(variant.id));
          btn.setAttribute('data-base-url', '/products/' + handle);
        }
      })
      .catch(function () {});
  }

  /* ═══════════════════════════════════════════════════════════════
     BOOT
  ═══════════════════════════════════════════════════════════════ */
  function init() {
    initCanvas();
    initCrystal();
    ensureVariantId('zkk-canvas-order-btn');
    ensureVariantId('zkk-crystal-order-btn');
    wireCartButton('zkk-canvas-order-btn');
    wireCartButton('zkk-crystal-order-btn');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
